module.exports = __webpack_public_path__ + "static/Canary_Wharf-b9d91e968456e2585ec014fe1fca2246.png";